import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { MyInvitableRolesDocument } from "#app/lib/data";

// The set of roles the actor is allowed to invite people into. Sourced
// from the role_invite_grant grid for the current user's roles, so role
// dropdowns can never offer a role the backend would reject.
export function useInvitableRoles(workspaceId: string) {
  const queryOptions = useMemo(
    () => ({ variables: { workspaceId }, skip: !workspaceId }),
    [workspaceId],
  );
  const { data, loading } = useQuery(MyInvitableRolesDocument, queryOptions);

  const allowedRoleIds = useMemo(
    () => (data?.myInvitableRoles ?? []).map((r) => r.id),
    [data],
  );

  return { allowedRoleIds, loading };
}
